'use strict';

require('plyr');

import { queryFirst, queryAll, hasClass } from '../domUtil';
const mainVideoClass = 'video-component-main';
const mobileVideoClass = 'video-component-mobile';

const initVideos = videoComponents => {
    if (!(videoComponents || []).length) {
        return;
    }

    videoComponents.forEach(videoComponent => {
        const mainVideo = queryFirst(`.${mainVideoClass}`, videoComponent);
        const mobileVideo = queryFirst(`.${mobileVideoClass}`, videoComponent);
        const allVideos = [mainVideo, mobileVideo].filter(Boolean);

        // Exclude init on hidden video template on PDP or already inited videos
        const targetVideos = Array.from(allVideos).filter(video => {
            return !video.closest('.product-video-template') && !video.plyr;
        });

        targetVideos.forEach(video => {
            const isPDP = hasClass(videoComponent, 'video-PDP');
            const isAutoplay = video.hasAttribute('autoplay');
            let controls = ['play-large', 'play', 'progress', 'fullscreen', 'mute'];
            let clickToPlay = true;

            if (!isPDP && isAutoplay) {
                controls = [];
                clickToPlay = false;
            }

            new Plyr(video, {
                hideControls: false,
                clickToPlay: clickToPlay,
                resetOnEnd: true,
                controls: controls,
                fullscreen: { iosNative: true }
            }).on('ready', (event) => {
                ['touchstart', 'touchmove', 'touchend', 'pointerdown', 'pointermove'].forEach(eventType => {
                    event.target.addEventListener(eventType, (e) => {
                        // if in fullscreen mode block Hammer gestures
                        if (document.fullscreenElement) {
                            e.stopPropagation();
                        }
                    }, { passive: true });
                });
            });
        });
    });
};

$('body').on('product:afterAttributeChange product:initVideos search:updateProducts', function () {
    initVideos(queryAll('.video-component'));
});

initVideos(queryAll('.video-component'));
